export const OCC_PREFIX = '/occ/v2/';
export const ASSETS_PATH = '/assets/';
export const ASM_PATH = '/assistedservicewebservices/';
export const OAUTH_PREFIX = '/oauth/';
export const IMPERVA_BYPASS_HEADER_NAME = 'X-RRS-ABP-Client-ID';
